import { request } from './request';

export const axiosBaseQuery = async ({ url, method = 'GET', data, params, options = {}, network, version }) =>
  request(url, {
    method,
    data,
    params,
    network,
    version,
    ...options,
  });

/**
 * Use this query as default query for new apis
 */
export const baseQuery = axiosBaseQuery;

/**
 * This query is intended for apis related to a network that usually works under
 * the path /collections/{id}/. Removes the necessity of adding the newtork id in
 * every endpoint.
 */
export const networkBaseQuery = ({ url, method = 'GET', data, params, options = {}, networkId }, { getState }) => {
  const { networks } = getState();

  return axiosBaseQuery({ url, method, data, params, options, network: networkId || networks?.active });
};

export const networkBaseQueryV2 = ({ url, method = 'GET', data, params, options = {}, networkId }, { getState }) => {
  const { networks } = getState();

  return axiosBaseQuery({ url, method, data, params, options, network: networkId || networks?.active, version: 'v2' });
};
